import React from 'react';
import {createRoot} from 'react-dom/client';
import { Router, Route, Private, Routes ,Outlet, withRouter } from 'components/Routing';
import AppContext from 'components/appContext';
import {EvaluationsRouting , ProcedureEvaluationsRouting} from './AppRouting';
import withAppStore from './components/appStore';
import GlobalHistory from 'components/GlobalHistory';
import config from 'root/../config';
import xhook from 'xhook';
import 'assets/css/general.less';

import EnterKeyClickWrapper from 'hooks/EnterKeyClickWrapper';
import AuthenticationPage from './scenes/Authentication';
import StudentPortal from './scenes/StudentPortal';
import NoMatch from "./scenes/NoMatch";
import userService from './services/userService';
import authService from 'services/authService';
import PortalNotification from 'components/PortalNotification';
import queryString from 'query-string'
import {i18nInit} from './internationalization/config'
import {I18nextProvider} from 'react-i18next';
import UIComponent from "components/UiComponent";
import Policy from 'components/Policy';

window.MEDSIS_CUSTOM = {};
window.MEDSIS_CUSTOM.dateFormat = config.dateFormat;
window.mainBundleLoaded = true;

xhook.after(function (request, response) {
    if (response.status == 401 && request.url.indexOf("authenticate/access_token") < 0 ) {
        window.goToPage('/authenticate');
        return;
    }
    /* status 222 comes from agreement policy redirect */
	if (response.status == 222 && typeof response.data !== 'undefined') {
		let dataObj = JSON.parse(response.data);
		if (typeof dataObj.REDIRECT_URL !== 'undefined' && dataObj.REDIRECT_URL != '') {
			if (typeof window.redirected_to_policy === 'undefined') {
				window.redirected_to_policy = true;
				window.location.replace(dataObj.REDIRECT_URL);
			}
			window.localStorage.setItem('redirected_to_policy', true);
		}
	}
});

class MainRoute extends React.Component {

    constructor(props) {
        super(props);        
        let query = queryString.parse(this.props.router.location.search);
        
        if (Object.keys(query).indexOf('authToken') >= 0) {
            authService.setToken(query.authToken);
        }
        if (Object.keys(query).indexOf('user_role') >= 0) {
            userService.setUserRole(query.user_role);
        }
        this.state = {
            areUserDetailsLoaded: false,
        }
    }

    componentDidMount() {
        if(userService.areUserDetailsLoadedAndRoleSet(this.context)) {
            this.setState({areUserDetailsLoaded: true});
        } else {
            userService.populateUserDetails(this.context, ()=> {
                this.setState({areUserDetailsLoaded: true});
            });   
        }
    }

    render() {        
        return (
            this.state.areUserDetailsLoaded ? <Outlet /> : null
        );
    }
}

const WithRouterMainRoute = withRouter(MainRoute);
MainRoute.contextType = AppContext;

export default class App extends React.Component {
    static contextType = AppContext;

    constructor(props) {
        super(props);
    }
    
    render(){
        return (
            <React.Fragment>
                <EnterKeyClickWrapper>
                    <I18nextProvider i18n={i18nInit}>
                    <Router basename={config.mainAppUrl}>               
                            <GlobalHistory
                                userRole={this.context.userDetails.hasOwnProperty('CURRENT_ROLE') ? this.context.userDetails.CURRENT_ROLE : null}
                            />
                            <Routes>
                                <Route path="/authenticate/mcauth/:macidResult/token" element={<AuthenticationPage />} />
                                <Route path="/authenticate/ldapId" element={<AuthenticationPage />} />
                                <Route path="/authenticate/externalId" element={<AuthenticationPage />} />
                                <Route path="/authenticate" element={<AuthenticationPage />} />
                                <Route path="/" element={<WithRouterMainRoute />}> 
                                <Route path="/" element={<Private component={StudentPortal} />} />                              
                                <Route path="evaluations/*" element={<EvaluationsRouting />} />
                                <Route path="procedureevaluations/*" element={<ProcedureEvaluationsRouting />} />                               
                                </Route>
                                <Route path="*" element={<NoMatch />}/>                            
                            </Routes>
                    </Router>
                    <PortalNotification portal={this.context.userDetails.hasOwnProperty('CURRENT_ROLE') ? this.context.userDetails.CURRENT_ROLE : null} show={this.context.showCurrentPortalInfo}/>
                    </I18nextProvider>
                    <UIComponent component="msgbox-container" />
                    <Policy />
                </EnterKeyClickWrapper>
            </React.Fragment>
        )
    }
}

const AppIndex =  withAppStore(App);
const root = createRoot(document.getElementById("main-container"));
root.render(<AppIndex />);
